import { render, staticRenderFns } from "./EditNewRequeriment.html?vue&type=template&id=771eb652&external"
import script from "./EditNewRequeriment.ts?vue&type=script&lang=ts&external"
export * from "./EditNewRequeriment.ts?vue&type=script&lang=ts&external"
import style0 from "./EditNewRequeriment.scss?vue&type=style&index=0&prod&lang=scss&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports